export const BRAND = {
  name: "Grafton Group",
  legal: "Chartwell (NZ) Ltd T/A Grafton Group",
  tagline: "Leave it to us",
  positioning: "Credit Recovery · Document Serving · Debt Management",
  credibility: "Authorised FEDS Network Agent",
  phone: "+64 27 242 2757",
  phoneHref: "tel:+6427242757",
  email: "graftongroup@chartwell.co.nz",
  address: "PO Box 12230, Chartwell 3248, Hamilton, New Zealand",
  bank: "Westpac Banking Corporation — 03-1318-0133844-00",
};

export const IMG = {
  hero: "https://static.prod-images.emergentagent.com/jobs/6fee9629-23ad-4647-b817-49a516003e2b/images/c97e53fec31e39e4b9168eed00d2055f649acd2961e14ef70174bd171b02e9e3.jpeg",
  credit: "https://static.prod-images.emergentagent.com/jobs/6fee9629-23ad-4647-b817-49a516003e2b/images/a49ad3349e7487ce8f30d4a315959c17f3120af4be518c1a2191ee7be5a328e7.jpeg",
  serving: "https://static.prod-images.emergentagent.com/jobs/6fee9629-23ad-4647-b817-49a516003e2b/images/21c34c9ed18f29f10a6f4324785f9ad074673e852d6375f5ac9e26a9322e9657.jpeg",
  debt: "https://static.prod-images.emergentagent.com/jobs/6fee9629-23ad-4647-b817-49a516003e2b/images/bcf9df4e2c34532594ada12280a2c435817b508cc1405dec434b60c41ec220af.jpeg",
  portrait: "https://static.prod-images.emergentagent.com/jobs/6fee9629-23ad-4647-b817-49a516003e2b/images/ca8d183e468b8d487d98cf805685cc4a5b209c56d4bedf846512eb587ea35e49.jpeg",
  emblem: "https://static.prod-images.emergentagent.com/jobs/6fee9629-23ad-4647-b817-49a516003e2b/images/944e5ec91de31bb6b3b6b15544dce36d878c6b9332ee42dd6d91fba2dfd4eb67.jpeg",
};
